import React from 'react';
import {StyledTextarea, Label} from './styles'
import {FieldError, FieldErrorsImpl, Merge} from 'react-hook-form'
import Grid from '../../../../molecules/Grid'
import ErrorMessage from '../ErrorMessage/ErrorMessage'
import Marker from '../Marker/Marker.js'
import { getErrorMessage } from '@/core/utils/errorUtils';


type TextAreaType = {
    label?: string
    name: string
    value?: string
    register: any
    onChange?: any
    error: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined
    placeholder: string
    isRequired?: boolean | undefined
    type?: string | undefined
};


const Textarea: React.FC<TextAreaType> = ({
        label,
        name,
        value,
        register,
        onChange,
        type,
        error,
        placeholder,
        isRequired,
    }) => {

    let rules = {};

    const errorMessage = getErrorMessage(error);

    return (
        <Grid col='1' gap='1'>
            {label && <Label htmlFor={name}>
                {label}: {isRequired && <Marker>*</Marker>}
            </Label>}

            <StyledTextarea
                className={`${error && 'isError'}`}
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                aria-describedby={`${name}-error-message`}
                {...register(name, rules)}
                readOnly={false}
                type={type}
            />

            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </Grid>
    );
};

export default Textarea
